import React from 'react';

const AlterarDocumentoDialog = ({ dialogAlterar, setDialogAlterar, onSubmeter, loading }) => {
  if (!dialogAlterar.isOpen) return null;

  const handleClose = () => {
    setDialogAlterar({ isOpen: false, documentoId: null, textoOriginal: '', instrucoes: '', nomeArquivo: '' });
  };

  return (
    <div className="dialog-overlay" onClick={handleClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>✏️ Alterar Documento: {dialogAlterar.nomeArquivo}</h3>
          <button className="btn-fechar" onClick={handleClose}>✖</button>
        </div>
        <div className="dialog-body">
          <label className="dialog-label">Instruções de Alteração:</label>
          <textarea
            className="dialog-textarea-instrucoes"
            value={dialogAlterar.instrucoes}
            onChange={(e) => setDialogAlterar(prev => ({ ...prev, instrucoes: e.target.value }))}
            placeholder="Descreva as alterações que deseja fazer no documento..."
            rows={8}
          />
        </div>
        <div className="dialog-footer">
          <button
            className="btn-gerar-novo"
            onClick={onSubmeter}
            disabled={loading || !dialogAlterar.instrucoes.trim()}
          >
            {loading ? '⏳ Gerando...' : '🔄 GERAR NOVO DOCUMENTO'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlterarDocumentoDialog;
